import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import type { PortInfoType } from '../../../../types'
import { inputWidth } from '../../add-visit-flow'

const typeOptions: { value: PortInfoType; label: string }[] = [
  // TODO: Continent option temporarily disabled - re-enable when needed
  // { value: 'continent', label: 'Continent' },
  { value: 'country', label: 'Country' },
  { value: 'port', label: 'Port' },
]

interface TypeSelectorProps {
  value?: PortInfoType
  onChange: (value: PortInfoType) => void
  error?: boolean
}

export function TypeSelector({ value, onChange, error }: TypeSelectorProps) {
  return (
    <FormControl
      className="tour-step-port-info-type-field"
      size="small"
      sx={{ width: inputWidth }}
      required
      error={error}
    >
      <InputLabel id="type-select-label">Type</InputLabel>
      <Select
        labelId="type-select-label"
        label="Type"
        value={value || ''}
        onChange={(e) => onChange(e.target.value as PortInfoType)}
        MenuProps={{ disablePortal: true }}
      >
        {typeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
